import { isContractAnomaly } from "app/utils/contractState";

const PAYMENT_ANOMALY = {
  unpaid: "Unpaid",
  disputed: "Disputed",
  disputed_review: "Disputed",
};
const UNSENT_EMAIL = new Set(["ready_to_send", "failed"]);

// Mirrors the backend's Needs Attention set; keep the two in sync.
export const getJobAnomalies = (detail) => {
  if (!detail) return [];
  const anomalies = [];
  const payment = PAYMENT_ANOMALY[detail.payment?.status];
  if (payment) anomalies.push(payment);
  if (isContractAnomaly(detail.contract?.status)) anomalies.push("Unsigned");
  if ((detail.emails || []).some((email) => UNSENT_EMAIL.has(email.status)))
    anomalies.push("Email not sent");
  return anomalies;
};
